export type NewsItem = {
  id: string;
  title: string;
  category: string;
  summary: string;
  date: string;
  source: string;
  image: string;
};

export const newsList: NewsItem[] = [
  {
    id: "n001",
    title: "《星际边缘》全球票房突破十亿，科幻题材再迎高光时刻",
    category: "行业新闻",
    summary:
      "上映三周，《星际边缘》凭借扎实的叙事与震撼的视觉跻身年度票房前列，也再次点燃了市场对原创科幻的信心。",
    date: "2026-10-12",
    source: "八戒影视资讯",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20article%20cover%2C%20deep%20blue%20space%20scene%20with%20planet%20and%20distant%20light%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20deep%20navy%20and%20cyan%20grading%2C%20simple%20composition%2C%20high%20detail&width=800&height=450&seq=bajie-news-001&orientation=landscape",
  },
  {
    id: "n002",
    title: "影评｜《长安谜案》：在繁华盛世里，藏着一座城的隐秘心事",
    category: "影评",
    summary:
      "从美术到群像，《长安谜案》用克制的镜头语言还原了一个既华丽又危险的盛唐，也让观众重新思考古装悬疑的可能性。",
    date: "2026-10-10",
    source: "八戒影视影评",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20article%20cover%2C%20ancient%20chinese%20night%20city%20with%20lanterns%20and%20mist%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20deep%20navy%20and%20amber%20grading%2C%20simple%20composition%2C%20high%20detail&width=800&height=450&seq=bajie-news-002&orientation=landscape",
  },
  {
    id: "n003",
    title: "《迷雾追凶》第二季官宣，原班人马回归定档明年春季",
    category: "行业新闻",
    summary:
      "口碑爆棚的悬疑剧集确认续订，主创表示新一季将把故事带到更北的海岸小镇，谜团也将进一步升级。",
    date: "2026-10-09",
    source: "八戒影视资讯",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20article%20cover%2C%20foggy%20harbor%20town%20at%20night%20with%20streetlights%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20deep%20navy%20and%20cold%20grey%20grading%2C%20simple%20composition%2C%20high%20detail&width=800&height=450&seq=bajie-news-003&orientation=landscape",
  },
  {
    id: "n004",
    title: "2026 秋季剧集观察：现实题材回暖，医疗与职业剧成新宠",
    category: "行业新闻",
    summary:
      "从《医者仁心》到多部待播职业剧，观众对贴近生活的故事表现出更强黏性，平台也加大了对现实题材的投入。",
    date: "2026-10-08",
    source: "八戒影视资讯",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20article%20cover%2C%20modern%20hospital%20corridor%20with%20clean%20lines%20and%20soft%20light%2C%20editorial%20style%2C%20serious%20atmosphere%2C%20deep%20teal%20and%20clean%20white%20grading%2C%20simple%20composition%2C%20high%20detail&width=800&height=450&seq=bajie-news-004&orientation=landscape",
  },
  {
    id: "n005",
    title: "影评｜《无声告白》：那些没说出口的爱，才是最难翻译的语言",
    category: "影评",
    summary:
      "影片以极简的室内调度与细腻的表演，讲述了一个移民家庭的情感断层。它不煽情，却处处令人动容。",
    date: "2026-10-06",
    source: "八戒影视影评",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20article%20cover%2C%20quiet%20house%20interior%20at%20dusk%20with%20warm%20window%20light%2C%20editorial%20style%2C%20melancholic%20atmosphere%2C%20deep%20teal%20and%20soft%20peach%20grading%2C%20simple%20composition%2C%20high%20detail&width=800&height=450&seq=bajie-news-005&orientation=landscape",
  },
  {
    id: "n006",
    title: "《山海之城》特效解析：一座漂浮城市是如何被“建”出来的",
    category: "幕后",
    summary:
      "特效团队分享了云雾模拟与建筑群延展的技术细节，揭秘这部奇幻片幕后庞大而精密的工业化流程。",
    date: "2026-10-05",
    source: "八戒影视幕后",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20article%20cover%2C%20floating%20ancient%20mountain%20city%20above%20clouds%20at%20golden%20hour%2C%20editorial%20style%2C%20epic%20atmosphere%2C%20deep%20teal%20and%20warm%20gold%20grading%2C%20simple%20composition%2C%20high%20detail&width=800&height=450&seq=bajie-news-006&orientation=landscape",
  },
  {
    id: "n007",
    title: "新片前瞻｜五部值得期待的年末华语电影",
    category: "行业新闻",
    summary:
      "从年代家族史诗到青春励志，年末档华语片类型丰富。我们梳理了五部最具看点的作品，供你提前锁定。",
    date: "2026-10-03",
    source: "八戒影视资讯",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20article%20cover%2C%20collage%20of%20film%20genre%20moods%20with%20deep%20teal%20tones%20and%20warm%20accents%2C%20editorial%20style%2C%20cinematic%20atmosphere%2C%20simple%20composition%2C%20high%20detail&width=800&height=450&seq=bajie-news-007&orientation=landscape",
  },
  {
    id: "n008",
    title: "影评｜《风起南洋》：用三代人的航程，写一封给故乡的长信",
    category: "影评",
    summary:
      "这部年代剧以家族史映照时代变迁。南洋的潮水与故土的山峦遥相呼应，构成了一部厚重的移民史诗。",
    date: "2026-10-01",
    source: "八戒影视影评",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20article%20cover%2C%20colonial%20era%20seaside%20town%20at%20dusk%20with%20wooden%20piers%2C%20editorial%20style%2C%20nostalgic%20atmosphere%2C%20deep%20teal%20and%20muted%20amber%20grading%2C%20simple%20composition%2C%20high%20detail&width=800&height=450&seq=bajie-news-008&orientation=landscape",
  },
  {
    id: "n009",
    title: "幕后｜《暗涌》如何用一场雨戏拍出整部剧的压迫感",
    category: "幕后",
    summary:
      "导演与摄影指导聊了聊那场被观众反复讨论的雨夜对决，从布光到调度，每一个细节都在为情绪服务。",
    date: "2026-09-28",
    source: "八戒影视幕后",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20article%20cover%2C%20night%20city%20street%20in%20rain%20with%20reflections%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20deep%20navy%20and%20cool%20blue%20grading%2C%20simple%20composition%2C%20high%20detail&width=800&height=450&seq=bajie-news-009&orientation=landscape",
  },
];